export const SALES_ORGANIZATION_EXPORT_ID = 'sales-organization';

export const SALES_ORGANIZATION_TITLE = 'Organización de Ventas';

export const LOCALIZED_PROPERTIES = {
  name: 'Nombre',
  statusId: 'Estado',
};
